import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { FAQS, waLink } from "../../data";
import { Reveal } from "./Reveal";

export const FAQ = () => (
  <section id="faq" className="relative py-24 sm:py-32 bg-[#faf7f2]">
    <div className="mx-auto max-w-5xl px-5 sm:px-8">
      <Reveal>
        <p className="uppercase text-xs tracking-[0.28em] text-[#8b5a2b] mb-4">
          Pertanyaan Umum
        </p>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#2c1e16] max-w-3xl leading-tight">
          Masih ragu? Ini jawabannya.
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-12 w-full">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-[#e5d9c5]"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-display text-xl sm:text-2xl text-[#2c1e16] hover:no-underline py-6"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#5c4033] text-base leading-relaxed pb-6 max-w-2xl">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="mt-12 text-center">
          <p className="text-[#5c4033]">Masih ada pertanyaan lain?</p>
          <a
            href={waLink("Halo Javanese Spa Jogja, saya mau bertanya tentang layanan Massage panggilan.")}
            target="_blank"
            rel="noreferrer"
            data-testid="faq-whatsapp-btn"
            className="mt-4 inline-block rounded-full bg-[#5c4033] text-[#faf7f2] px-8 py-4 text-sm hover:bg-[#2c1e16] transition-colors"
          >
            Tanya Langsung via WhatsApp
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
